import { render, staticRenderFns } from "./WorkRecord.vue?vue&type=template&id=595c1987&scoped=true"
import script from "./WorkRecord.vue?vue&type=script&lang=ts"
export * from "./WorkRecord.vue?vue&type=script&lang=ts"
import style0 from "./WorkRecord.vue?vue&type=style&index=0&id=595c1987&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c1987",
  null
  
)

export default component.exports